(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fg-cart-upsell"] && !Shopify.designMode) return;
  try {
    class WICartUpsell extends FGUpsellCarousel {
    #strikethroughPrice = '';

    constructor() {
      super();
      this.#strikethroughPrice = this.dataset.strikethroughPrice;
      this.cartDrawerObserver = new MutationObserver((mutations, observer) => {
        const classMut = mutations.find((mut) => mut.attributeName === 'class');
        if (classMut) {
          setTimeout(() => {
            this.flickity.resize();
          }, 100);
        }
      });
    }

    async connectedCallback() {
      await super.connectedCallback();
      this.cartDrawerObserver.observe(document.getElementById('Cart-Drawer'), { attributes: true });
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      this.cartDrawerObserver.disconnect();
    }

    getTemplateConfig() {
      return {
        ...super.getTemplateConfig(),
        atcTemplateId: 'fg-cart-upsell-atc-tpl',
      };
    }

    getFlickityConfig() {
      return {
        cellAlign: 'center',
        contain: false,
      };
    }

    setPopulatedItem(carouselSlide, recommendation) {
      super.setPopulatedItem(carouselSlide, recommendation);
      if (!this.#strikethroughPrice) {
        return;
      }
      if (this.isStrikethroughEligible(recommendation)) {
        carouselSlide.querySelector('[data-item-price]').textContent = `$${this.#strikethroughPrice}`;
      }
    }

    isStrikethroughEligible(product) {
      if (product.type === 'Bottle' && !product.tags.includes('no-strikethrough')) {
        return true;
      }
      return false;
    }

    onEmptyRecommendations() {
      const thisSection = this.closest('.fg-cart-upsell-container');
      thisSection.style.display = 'none';
    }

    async onAddToCart(event) {
      const sectionConfigs = [
        { section: 'cart-drawer', childSelector: '#Cart-Drawer', replacesSelector: '#Cart-Drawer' },
        {
          section: 'cart-bubble',
          childSelector: '#cart-drawer-toggle .thb-item-count',
          replacesSelector: '#cart-drawer-toggle .thb-item-count',
        },
      ];
      await super.onAddToCart(event, sectionConfigs);

      const cartDrawer = document.getElementById('Cart-Drawer');
      cartDrawer?.notesToggle();
      cartDrawer?.removeProductEvent();
      cartDrawer?.classList.add('active');
      document.body.classList.add('open-cart');
      document.body.classList.add('open-cc');
      document.dispatchEvent(new Event('cart:item-added'));
    }
  }
  customElements.define('wi-cart-upsell', WICartUpsell);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fg-pack-upsell-modal"] && !Shopify.designMode) return;
  try {
    const container = document.querySelector('.pack-upsell-bg-container');
  const itemDataScript = document.querySelector('#pack-upsell-data');
  const itemTemplate = document.querySelector('#pack-upsell-item-tpl');
  const dotTemplate = document.querySelector('#pack-upsell-dot-tpl');
  const paginationTemplate = document.querySelector('#pack-upsell-pagination-tpl');
  const priceNode = document.querySelector('.upsell-price .amount.discounted');
  const comparePriceNode = document.querySelector('.upsell-price del .amount');

  const slideshow = container.querySelector('#pack-upsell-carousel');
  const pagination = container.querySelector('#pack-upsell-pagination');
  const closeButtons = container.querySelectorAll('.modal-close-btn');
  const submitButton = container.querySelector('.modal-submit-btn');

  const upsellId = container.dataset.upsellId;

  let flkty = null;

  const sectionsToRender = [
    {
      id: 'Cart',
      section: 'main-cart',
      selector: '.thb-cart-form',
    },
    {
      id: 'Cart-Drawer',
      section: 'cart-drawer',
      selector: '.cart-drawer',
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count',
    },
  ];

  // Hide the modal on clicks outside of it
  container.addEventListener('click', event => {
    const target = event.target;
    if(event.target.classList.contains('pack-upsell-bg-container')) {
      container.classList.remove('show');
    }
  });
  closeButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      container.classList.remove('show');
    });
  });
  submitButton.addEventListener('click', (event) => {
    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: upsellId,
            quantity: 1,
          },
        ],
        sections: sectionsToRender.map((section) => section.section),
        section_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        sectionsToRender.forEach((section) => {
          if (!document.getElementById(section.id)) {
            return;
          }
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = getSectionInnerHTML(response.sections[section.section], section.selector);
          if (section.id === 'Cart-Drawer') {
            document.getElementById('Cart-Drawer')?.notesToggle();
            document.getElementById('Cart-Drawer')?.removeProductEvent();
          }
          if (section.id === 'Cart' && typeof Cart !== 'undefined') {
            new Cart().renderContents(response);
          }
        });

        document.dispatchEvent(new Event('cart:item-added'));

        container.classList.remove('show');
      });
  });

  document.addEventListener('cart:item-added', (event) => {
    if (!upsellId) {
      return;
    }
    container.classList.add('show');
    flkty.reloadCells();
    flkty.resize();
    flkty.setGallerySize();
  });

  const getSectionInnerHTML = (html, selector = '.shopify-section') => {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  };

  const getMetafieldValues = (product) => {
    const fields = [];
    const country = product.metafields.find((metafield) => metafield && metafield.key === 'country');
    if (country) {
      fields.push(country.value);
    }
    const profile = product.metafields.find((metafield) => metafield && metafield.key === 'profile');
    if (profile) {
      fields.push(profile.value);
    }
    const body = product.metafields.find((metafield) => metafield && metafield.key === 'body');
    if (body) {
      fields.push(body.value);
    }
    return fields;
  };

  const loadUpsellProducts = async () => {
    if (!upsellId) {
      return;
    }

    const itemData = JSON.parse(itemDataScript.textContent);

    // Originally, this was designed for the upsell item being a pack with the pack_products field filled out
    // Now, the possible upsell products are both 'active' or 'unlisted' status products:
    // - Packs with a pack_products breakout (shows the full carousel of wines)
    // - Packs without a pack_products breakout (shows a single item with a centered title and variant image)
    // - Single bottles of wine (shows a single wine card like those in the full carousel)
    // The only thing to note is that if a pack has pack_products, those items in the pack_products list must be 'active' status
    let packProducts = null;
    let noBreakoutItem = false;
    if (itemData.pack_products) {
      packProducts = itemData.pack_products;
    } else {
      noBreakoutItem = true;
      packProducts = [{ variant_id: `gid://shopify/ProductVariant/${upsellId}`, quantity: 1 }];
      const descriptionContainer = container.querySelector('.pack-upsell-container .upsell-description');
      descriptionContainer.textContent = '';
    }

    let upsellProductVariantsData = null;
    let upsellProductVariantsErrors = null;
    if (noBreakoutItem) {
      upsellProductVariantsData = {
        nodes: [
          {
            id: `gid://shopify/ProductVariant/${itemData.variant_id}`,
            product: {
              id: `gid://shopify/Product/${itemData.product_id}`,
              title: `${itemData.product_title}`,
              handle: '',
              featuredImage: {
                url: itemData.featured_image,
                altText: '',
              },
              metafields: [
                { key: 'country', value: itemData.variant_metafield_country },
                { key: 'profile', value: itemData.variant_metafield_profile },
                { key: 'body', value: itemData.variant_metafield_body },
              ],
            },
          },
        ],
      };
    } else {
      const upsellProductVariantsQuery = `
        query VariantsByIds($ids: [ID!]!) {
          nodes(ids: $ids) {
            ... on ProductVariant {
              id
              product {
                id
                title
                handle
                featuredImage { url( transform: { maxWidth: 600, maxHeight: 600 } ) altText }
                metafields(identifiers: [
                  { namespace: "custom", key: "country" },
                  { namespace: "custom", key: "profile" },
                  { namespace: "custom", key: "body" }
                ]) { key value }
              }
            }
          }
        }
      `;
      const upsellProductVariantsVariables = {
        ids: packProducts.map((item) => `${item.variant_id}`),
      };
      const result = await STOREFRONT_CLIENT.request(upsellProductVariantsQuery, {
        variables: upsellProductVariantsVariables,
      });
      upsellProductVariantsData = result.data;
      upsellProductVariantsErrors = result.errors;
    }

    priceNode.textContent = `$${itemData.price_formatted}`;
    priceNode.setAttribute('data-sl-attribute-p', `${itemData.product_id}`);
    if (!itemData.compare_at_price) {
      comparePriceNode.textContent = '';
      comparePriceNode.removeAttribute('data-sl-attribute-cap');
    } else {
      comparePriceNode.textContent = `$${itemData.compare_at_price_formatted}`;
      comparePriceNode.setAttribute('data-sl-attribute-cap', `${itemData.product_id}`);
    }
    const slideshowDots = [];
    upsellProductVariantsData.nodes.forEach((node, index) => {
      const bottleData = packProducts.find((product) => product.variant_id === node.id);
      const slideContent = itemTemplate.content.cloneNode(true);

      if (noBreakoutItem && itemData.product_type !== 'bottle') {
        const bottleItemContainer = slideContent.querySelector('.upsell-item');
        bottleItemContainer.classList.add('image-full');
      }

      const bottleCountContainer = slideContent.querySelector('.upsell-item-bottle-count');
      bottleCountContainer.textContent = `${bottleData.quantity} ${bottleData.quantity > 1 ? 'Bottles' : 'Bottle'}`;

      const bottleTitleContainer = slideContent.querySelector('.upsell-item-name');
      bottleTitleContainer.textContent = node.product.title;

      const productMetafieldsContainer = slideContent.querySelector('.upsell-item-metafields');
      const metafields = getMetafieldValues(node.product);
      metafields.forEach((metafield) => {
        const divNode = document.createElement('div');
        const spanNode = document.createElement('span');
        spanNode.textContent = metafield;
        divNode.appendChild(spanNode);
        productMetafieldsContainer.appendChild(divNode);
      });

      const slideContentImageContainer = slideContent.querySelector('.upsell-item-image');
      const productImageNode = document.createElement('img');
      productImageNode.setAttribute('src', node.product.featuredImage.url);
      productImageNode.setAttribute('width', 'auto');
      productImageNode.setAttribute('height', 'auto');
      slideContentImageContainer.appendChild(productImageNode);

      const dotContent = dotTemplate.content.cloneNode(true);
      const dotNode = dotContent.querySelector('.dot');
      dotNode.setAttribute('data-index', index);
      dotNode.addEventListener('click', (event) => {
        flkty.select(event.target.dataset.index);
      });

      slideshowDots.push(dotContent);
      slideshow.appendChild(slideContent);
    });
    if (upsellProductVariantsData.nodes.length > 1) {
      const paginationContent = paginationTemplate.content.cloneNode(true);
      const paginationDots = paginationContent.querySelector('.carousel-dots');
      slideshowDots.forEach((dot) => {
        paginationDots.appendChild(dot);
      });
      pagination.appendChild(paginationContent);
      pagination.querySelectorAll('.dot-container')[0].classList.add('active');
    }

    flkty = new Flickity(slideshow, {
      cellAlign: 'center',
      contain: true,
      prevNextButtons: false,
      pageDots: false,
    });

    const prevButton = pagination.querySelector('.carousel-prev');
    const nextButton = pagination.querySelector('.carousel-next');
    if (prevButton) {
      prevButton.addEventListener('click', () => {
        flkty.previous();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        flkty.next();
      });
    }

    flkty.on('change', (index) => {
      const dotContainers = pagination.querySelectorAll('.dot-container');
      for (let ii = 0; ii < dotContainers.length; ii++) {
        if (ii === index) {
          dotContainers[ii].classList.add('active');
        } else {
          dotContainers[ii].classList.remove('active');
        }
      }
    });
  };

  (async () => {
    loadUpsellProducts();
  })();
  } catch(e) { console.error(e); }
})();

})();
